<h1 mat-dialog-title>Hi x</h1>
<div mat-dialog-content>
  <p>What's your favorite animal? {{ data.name }} </p>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="'cerroado'" cdkFocusInitial>Ok</button>
</div>
